export const emailRegex = new RegExp(/^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/);
export const nameRegex = new RegExp(/^[a-zA-Z]+ [a-zA-Z]+$/);
export const passwordRegx = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#?!@$%^&*-])[A-Za-z\d#?!@$%^&*-]{8,30}$/);
